<template>
  <div class="page_config">
    <h1>Nastavení systému</h1>

    <label for="servantDiscount">Sleva pro dobrovolníky</label>
    <inputerNumber id="servantDiscount" :paths="['config', 'servantDiscount']" :min="0" />

    <label for="MaxAccommodationFilledWithQuotes">Část zabraná kvótou</label>
    <inputerNumber id="MaxAccommodationFilledWithQuotes" :paths="['config', 'maxAccommodationFilledWithQuotes']" :min="0" :max="1" :step="0.1" />

    <label for="AccommodationQuoteCountAt">Zafixování kvóty</label>
    <inputerDate id="AccommodationQuoteCountAt" :paths="['config', 'accommodationQuoteCountAt']" :time="true" />

    <label for="AccommodationWithoutQuotes_StartAt">Registrace bez kvót</label>
    <inputerDate id="AccommodationWithoutQuotes_StartAt" :paths="['config', 'accommodationWithoutQuotes_StartAt']" :time="true" />

    <label for="ShirtPrice">Cena trička</label>
    <inputerNumber id="ShirtPrice" :paths="['config', 'shirtPrice']" />

    <label for="ShirtGraphicUrl">Obrázek trička</label>
    <inputer id="ShirtGraphicUrl" :paths="['config', 'shirtsGraphicUrl']" />
    
    <label for="EventFirstDay">Turnaj začíná</label>
    <inputerDate id="EventFirstDay" :paths="['config', 'eventFirstDay']" />
    
    <label for="EventLastDay">Turnaj končí</label>
    <inputerDate id="EventLastDay" :paths="['config', 'eventLastDay']" />

    <label for="accommodationRegistrationEndAt">Odhlašování ubytování končí</label>
    <inputerDate id="accommodationRegistrationEndAt" :paths="['config', 'accommodationRegistrationEndAt']" :time="true" />

    <label for="shirtsRegistrationEndAt">Přihlašování triček končí</label>
    <inputerDate id="shirtsRegistrationEndAt" :paths="['config', 'shirtsRegistrationEndAt']" :time="true" />

    <label for="teamAndRoyRegistrationEndAt">Přihlašování týmů končí</label>
    <inputerDate id="teamAndRoyRegistrationEndAt" :paths="['config', 'teamAndRoyRegistrationEndAt']" :time="true" />
  </div>
</template>

<script>
import inputer from "../../components/inputer";
import inputerNumber from "../../components/inputer-number";
import inputerDate from "../../components/inputer-date";

export default {
  name: "admin_config",
  components: {
    inputer,
    inputerNumber,
    inputerDate
  }
};
</script>

<style lang="sass">
.page_config
  display: grid
  align-items: center
  grid-template-columns: 4fr 5fr
  grid-column-gap: 1rem

  h1
    grid-column: 1 / 3
    justify-self: center
  label
    grid-column: 1
    justify-self: end
    &:after
      content: ' :'
  & > div
    grid-column: 2
    max-width: 30rem
</style>
